import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@dixa/lib-shared-habla';
import { MenuItem } from './components/menuItem/menuItem';
import styles from './contextMenu.module.scss';
export function ContextMenu({ position, handlers, loading, disabled, }) {
    return (_jsx(Box, Object.assign({ background: "neutral.000", boxShadow: "100", borderRadius: "100", style: {
            overflow: 'hidden',
            position: 'fixed',
            left: position[0],
            top: position[1],
        } }, { children: _jsxs("ul", Object.assign({ className: styles.list }, { children: [_jsx(MenuItem, { disabled: disabled.isAlignDisabled, loading: loading.isAlignLoading, onClick: handlers.onAlign, content: "Align" }), _jsx(MenuItem, { disabled: disabled.isArrangeDisabled, loading: loading.isArrangeLoading, onClick: handlers.onArrange, content: "Arrange nodes" }), _jsx(MenuItem, { disabled: disabled.isDeleteDisabled, onClick: handlers.onDelete, color: "error", content: "Delete" })] })) })));
}
